import { accountLabelFor } from './roleTerm';

export const isCorporateAccount = user => ['admin', 'company_manager'].includes(user?.role);
export const isPropertyAccount = user => user?.role === 'property_manager';
export const isFieldAccount = user => ['manager', 'regional_manager', 'supervisor', 'crew_leader', 'agent', 'site_agent', 'staff', 'driver', 'cleaner', 'valet'].includes(user?.role);
export const readable = value => String(value || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

export function accountPosition(user) {
  if (user?.position || user?.title) return user.position || user.title;
  if (isPropertyAccount(user)) return readable(user.pm_sub_role || 'property_manager');
  if (['tenant', 'resident', 'tenant_resident'].includes(user?.role)) return accountLabelFor(user);
  return readable(user?.admin_position || user?.role || 'Member');
}

export function accountFullName(user) {
  return [user?.first_name, user?.middle_name, user?.last_name].filter(Boolean).join(' ').trim() || user?.name || 'Name not provided';
}

// Initial-only middle names are a profile-page presentation, never a stored rename.
export function profileDisplayName(user) {
  const initials = value => String(value || '').trim().split(/\s+/).filter(Boolean).map(part => `${Array.from(part)[0].toUpperCase()}.`).join(' ');
  if (!user?.first_name && !user?.last_name) {
    // Generated account titles are not a person's registered name.
    if (user?.is_demo || user?.demo_suite) return '';
    // A multi-word surname is not an unregistered middle name.
    return String(user?.name || '').trim();
  }
  const middle = String(user?.middle_name || user?.middle_initial || '').trim();
  return [user?.first_name, initials(middle), user?.last_name].filter(Boolean).join(' ');
}

export function fieldService(user) {
  const service = String(user?.primary_service || user?.role_type || '').toLowerCase();
  if (service === 'both') return 'Valet / Cleaners';
  if (service.includes('clean') || service === 'commercial') return 'Cleaners';
  return service.includes('valet') ? 'Valet' : 'Field Staff';
}